import { render, staticRenderFns } from "./trabajadorNuevo.vue?vue&type=template&id=43a00742&"
import script from "./trabajadorNuevo.vue?vue&type=script&lang=js&"
export * from "./trabajadorNuevo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports